/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _get from 'lodash/get'
import { analytics } from 'services/Analytics'
import { ROUTES } from 'constants/routes'
import { ALERTS } from 'constants/alerts'
import { SUBSCRIPTION_STATUS } from 'constants/subscription'
import { withLocalization } from 'hocs/localization'
import { loading } from 'hocs/loading'
import { isUserAuthorizated } from 'redux-app/selectors/auth'
import { onChangeSubscriptionPlan, onGetSubscriptionsPlans } from 'redux-app/actionCreators/subscription'
import { createAlert } from 'redux-app/modules/alerts'
import { selectPlan } from 'redux-app/modules/subscriptions'
import { getSubscriptionStatus, getUserSubscription, isUserAbleToOpenProfile } from 'redux-app/selectors/user'
import { getSubscriptionPlans } from 'redux-app/selectors/subscription'
import PlanChoice from './PlanChoice'

export default compose(
  withLocalization('profile.planChoose'),
  connect(
    (state) => {

      const isUserLogin = isUserAuthorizated(state)
      const plans = getSubscriptionPlans(state)
      .sort((a, b) => {

        if (a.weight === b.weight)
        {
          return !!a.activationFee ? 1 : -1
        }

        return a.weight > b.weight ? 1 : -1
      })

      plans.forEach(plan => {
        plan['visible'] = false;
      });

      const groupByCategory = plans.reduce((group, plan) => {
        group[plan.weight] = group[plan.weight] ?? []
        group[plan.weight].push(plan)
        return group
      }, {})

      for (const item in groupByCategory) {
        groupByCategory[item][0].visible = true
      }

      return {
        isUserLogin,
        activePlanId: _get(getUserSubscription(state), 'planId'),
        plans,
        groupedPlans: groupByCategory,
        subscriptionStatus: getSubscriptionStatus(state),
        isUserAbleToOpenProfile: isUserAbleToOpenProfile(state),
      }
    },
    {
      onChangeSubscriptionPlan,
      onGetSubscriptionsPlans,
      createAlert,
      selectPlan,
    },
  ),
  withRouter,
  withHandlers({
    onChangePlan: ({
      onChangeSubscriptionPlan,
      history,
      subscriptionStatus,
      createAlert,
      activePlanId,
      plans,
    }) => planId => {
      const newPlan = plans.find(plan => plan.id === planId)
      return onChangeSubscriptionPlan(planId)
        .then(() => {
          const oldPlan = plans.find(plan => plan.id === activePlanId)
          if (newPlan.price > oldPlan.price) {
            analytics.upgradePlan({ planName: newPlan.name })
          } else {
            analytics.downgradePlan({ planName: newPlan.name })
          }
          if (subscriptionStatus === SUBSCRIPTION_STATUS.pendingConfirmation) {
            history.replace(ROUTES.profile.view)
            createAlert({ name: ALERTS.successChangeSubscription })
            return
          }
          history.push(ROUTES.profile.changePlan.newPlanAccepted)
        })
    },
    onShowTerms: ({ plans, selectPlan, history }) => planId => {
      const newPlan = plans.find(plan => plan.id === planId)
      selectPlan(newPlan.id)
      return history.push(ROUTES.profile.changePlan.terms)
    },
  }),
  lifecycle<any, any>({
    componentWillMount () {
      this.props.onGetSubscriptionsPlans()
        .then(() => {
          this.setState({
            loadProgress: 100,
          })
        })
        .catch(() => {
          this.setState({
            loadProgress: 100,
          })
        })
    },
  }),
  loading,
)(PlanChoice)
